module.exports = __webpack_public_path__ + "img/ni.4a1d8be2.svg";